export class AlertDialog {

  static show(title, message, confirmText = 'OK', cancelText = 'Cancel') {
    const modal = document.querySelector('#alert-dialog');
    if(!modal) {
      return;
    }

    const titleElement = modal.querySelector('.title');
    const messageElement = modal.querySelector('.message');
    const confirmButton = modal.querySelector('.confirm-button');
    const cancelButton = modal.querySelector('.cancel-button');

    titleElement.innerText = title;
    messageElement.innerHTML = `<span>${message}</span>`;
    confirmButton.innerText = confirmText;
    cancelButton.innerText = cancelText;

    const promise = new Promise((resolve, reject) => {
      confirmButton.addEventListener('click', () => {
        modal.closeModal();
        resolve(true);
      });

      cancelButton.addEventListener('click', () => {
        modal.closeModal();
        resolve(false);
      });
    });

    modal.openModal();
    return promise;
  }
}